import './form-popup.scss'

class FormPopup {
    buttons
    popups
    registry
    constructor() {
        this.buttons = document.querySelectorAll('[data-form-popup-open]')
        this.popups = document.querySelectorAll('[data-form-popup]')
        this.registry = Array.from(this.popups).reduce((acc, popup) => ({
            ...acc,
            [popup.dataset.formPopup]: popup,
        }), {})
        Array.from(this.popups).map(popup => this.init(popup))
    }

    init(popup) {
        Array.from(this.buttons).map(button => button.addEventListener('click', e => {
            e.preventDefault();
            const id = button.dataset.formPopupOpen;
            this.registry[id].classList.add('active');
        }))

        const closeButtons = popup.querySelectorAll('[data-form-popup-close]');

        Array.from(closeButtons).map(btn => btn.addEventListener('click', () => {
            this.close(popup);
        }));
    }

    close(el) {
        el.classList.remove('active');
    }
}

new FormPopup();
